// extracted by mini-css-extract-plugin
export default {"root":"participantView_root__eaRum"};